import "moment/locale/pt-br";
import "react-datetime/css/react-datetime.css";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    FormControl,
    FormLabel,
    Flex,
    Input,
    useColorModeValue,
    useDisclosure,
} from "@chakra-ui/react";
import { FilterContainer } from "components/Tables/FilterContainer";
import DateTime from "react-datetime";
import { LOCALE_PT_BR } from "constants/date-time";
import SearchSelect from "components/SearchSelect/SearchSelect";
import { useCustomToast } from "components/CustomToast/CustomToast";
import { agentsService } from "services/agentsService";
import { formatDate } from "utils/utils";

export const AgentTrackingFilter = (props) => {
    const { t } = useTranslation('common');
    const { onFilter } = props;
    const { isOpen, onToggle } = useDisclosure();
    const showToast = useCustomToast();
    const [agents, setAgents] = useState([]);
    const [agentId, setAgentId] = useState("");
    const [date, setDate] = useState("");
    const placeholderColor = useColorModeValue("gray.300", "gray.400");

    const fetchAgents = async () => {
        try {
            const response = await agentsService.list({ pageSize: 999 });
            setAgents(response?.content || []);
        } catch (err) {
            showToast({
                title: t(err?.message),
                status: "error",
            });
        }
    };

    const handleToggle = () => {
        onToggle();
    };

    const onFilterHandler = () => {
        onFilter({
            id_agente: agentId || null,
            data: date ? formatDate(date) : "",
        });
    };

    const onClearHandler = () => {
        setAgentId("");
        setDate("");
        onFilter({
            id_agente: null,
            data: "",
        });
    };

    useEffect(() => {
        fetchAgents();
    }, []);

    return (
        <FilterContainer
            w='125px'
            fontSize='sm'
            fontWeight='bold'
            variant="light"
            isOpen={isOpen}
            onToggle={handleToggle}
            onFilter={onFilterHandler}
            onClear={onClearHandler}
        >
            <Flex w="100%" gap="4" justify="space-between">
                <FormControl minW="350px">
                    <FormLabel>
                        {t("reports.agent-tracking.filters.agent.label")}
                    </FormLabel>
                    <SearchSelect
                        id="agent-select"
                        value={agentId}
                        onChange={(e) => setAgentId(e.currentTarget?.value || "")}
                        valueField="id"
                        displayField={["codigo", "nome"]}
                        items={agents}
                        isDisabled={!agents.length}
                        placeholder={t("reports.agent-tracking.filters.agent.placeholder")}
                    />
                </FormControl>

                <FormControl w="230px">
                    <FormLabel>
                        {t("reports.agent-tracking.filters.date.label")}
                    </FormLabel>
                    <DateTime
                        locale={LOCALE_PT_BR}
                        closeOnSelect
                        timeFormat={false}
                        inputProps={date ? undefined : { value: "", placeholder: t("system.placeholders.date") }}
                        renderInput={(props) => (
                            <Input
                                {...props}
                                fontSize="sm"
                                _placeholder={{ color: placeholderColor, fontSize: "sm" }}
                            />
                        )}
                        onChange={date => setDate(date)}
                    />
                </FormControl>
            </Flex>
        </FilterContainer>
    );
}